export const GET_OPERATION_INFORMATION = 'GET_OPERATION_INFORMATION';
export const SET_OPERATION_INFORMATION = 'SET_OPERATION_INFORMATION';
